// 判断数据类型

export const isObject = (obj: any) => {
    return Object.prototype.toString.call(obj) === '[object Object]';
};

export const isString = (obj: any) => {
    return Object.prototype.toString.call(obj) === '[object String]';
};

export const isArray = (obj: any) => {
    return Object.prototype.toString.call(obj) === '[object Array]';
};

export const isNumber = (obj: any) => {
    return Object.prototype.toString.call(obj) === '[object Number]';
};

export const isNumberStr = (obj: any) => {
    return isNumber(obj) || !isNaN(Number(obj));
};

// 检查字符串是否为合法的JSON字符串
export function isJsonString(str: string | unknown): boolean {
    if (!isString(str)) return false;
    try {
        const obj = JSON.parse(str as string);
        return isObject(obj);
    } catch {
        return false;
    }
}
